<template>
    <section class="container-fluid" :class="(cssClass || 'header-list-type-1')">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="wrp">
                        <div class="content">
                            <slot name="content"></slot>
                        </div>
                        <div v-if="showActions && $slots.actions" class="actions">
                            <slot name="actions"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'HeaderList',
        props: {
            showActions: {
                type: Boolean,
                default: true
            },
            cssClass: {
                type: String,
                default: ''
            }
        }
    }
</script>
